var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-select',{attrs:{"placeholder":_vm.placeholder,"clearable":_vm.clearable,"filterable":_vm.filterable,"options":_vm.showOptions,"size":_vm.size,"disabled":_vm.disabled},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }